import React from "react";
import "./AdminCollections.less";
import Api, {Utils} from "../../Api";
import AutoCompleteEditor from "./AutoCompleteEditor.js";
import FontAwesome from "react-fontawesome";
import PropTypes from "prop-types";
import ReactDataGrid from "react-data-grid";
import {Toolbar, Editors, Formatters, Menu, Data} from "react-data-grid-addons";
const {CheckboxEditor} = Editors;
const {ImageFormatter} = Formatters;
const Selectors = Data.Selectors;
let ContextMenu = Menu.ContextMenu;
let MenuItem = Menu.MenuItem;

export default class AdminCollectionEdit extends React.Component {
  constructor(props) {
    super(props);

    this.onGridSort = this.onGridSort.bind(this);
    this.onAddFilter = this.onAddFilter.bind(this);
    this.onClearFilters = this.onClearFilters.bind(this);
    this.searchBrands = this.searchBrands.bind(this);
    this.getColumns = this.getColumns.bind(this);
    this.getRowCount = this.getRowCount.bind(this);
    this.getRows = this.getRows.bind(this);
    this.getRow = this.getRow.bind(this);
    this.onGridRowUpdated = this.onGridRowUpdated.bind(this);
    this.onCellChange = this.onCellChange.bind(this);
    this.getBrandData = this.getBrandData.bind(this);
    this.updateEmails = this.updateEmails.bind(this);
    this.emailToRow = this.emailToRow.bind(this);

    this.state = {
      rows: [],
      filters: {},
      sortColumn: null,
      sortDirection: null,
      loading: true
    };

    this.columns = [
      {
        key: 'send',
        name: 'Send?',
        width: 80,
        formatter: <CheckboxEditor onCellChange={this.onCellChange} />,
        onCellChange: this.onCellChange,
        sortable: true
      },
      {
        key: 'user_name',
        name: 'Customer',
        width: 150,
        resizable: true,
        filterable: true,
        sortable: true
      },
      {
        key: 'retailer_name',
        name: 'Retailer',
        width: 150,
        resizable: true,
        filterable: true,
        sortable: true
      },
      {
        key: 'subject',
        name: 'Subject',
        width: 90,
        resizable: true,
        editable: true,
        filterable: true,
        sortable: true
      },
      {
        key: 'last_sent_at',
        name: 'Last sent at',
        width: 110,
        resizable: true,
        sortable: true
      },
      {
        key: 'send_at',
        name: 'Send at (' + Utils.getTimezoneCode() + ')',
        width: 160,
        resizable: true,
        editable: true,
        filterable: true,
        sortable: true
      },
      {
        key: 'brand1',
        name: 'Brand 1',
        width: 100,
        resizable: true,
        editor: <AutoCompleteEditor options={[]} search={this.searchBrands}/>,
        filterable: true,
        sortable: true
      },
      {
        key: 'brand1_image_url',
        name: 'Img1',
        width: 55,
        resizable: false,
        formatter: ImageFormatter
      },
      {
        key: 'brand1_description',
        name: 'Description 1',
        width: 100,
        resizable: true
      },
      {
        key: 'brand2',
        name: 'Brand 2',
        width: 100,
        resizable: true,
        editor: <AutoCompleteEditor options={[]} search={this.searchBrands}/>,
        filterable: true,
        sortable: true
      },
      {
        key: 'brand2_image_url',
        name: 'Img2',
        width: 55,
        resizable: false,
        formatter: ImageFormatter
      },
      {
        key: 'brand2_description',
        name: 'Description 2',
        width: 100,
        resizable: true
      },
      {
        key: 'brand3',
        name: 'Brand 3',
        width: 100,
        resizable: true,
        editor: <AutoCompleteEditor options={[]} search={this.searchBrands}/>,
        filterable: true,
        sortable: true
      },
      {
        key: 'brand3_image_url',
        name: 'Img3',
        width: 55,
        resizable: false,
        formatter: ImageFormatter
      },
      {
        key: 'brand3_description',
        name: 'Description 3',
        width: 100,
        resizable: true
      },
      {
        key: 'brand4',
        name: 'Brand 4',
        width: 100,
        resizable: true,
        editor: <AutoCompleteEditor options={[]} search={this.searchBrands}/>,
        filterable: true,
        sortable: true
      },
      {
        key: 'brand4_image_url',
        name: 'Img4',
        width: 55,
        resizable: false,
        formatter: ImageFormatter
      },
      {
        key: 'brand4_description',
        name: 'Description 4',
        width: 100,
        resizable: true
      }
    ];
  }

  componentWillMount() {
    this.loadPendingEmails(null);
  }

  loadPendingEmails(request) {
    this.setState({loading: true});

    if (!request) {
      // Reset all current rows.
      this.setState({rows: []});
    }

    Api.getPendingRecommendationEmails(request).then(
      (response) => {
        let newRows = [];
        let index = this.state.rows.length;
        response.pending_emails.forEach((email) => {
          newRows.push(this.emailToRow(email, index));
          index++;
        });

        let rows = this.state.rows.concat(newRows);
        this.setState({rows: rows});
        if (response.next_request) {
          // Keep loading!
          this.loadPendingEmails(response.next_request);
        } else {
          this.setState({loading: false});
        }
      },
      (error) => {
        alert(error.message);
      }
    );
  }

  onGridSort(sortColumn, sortDirection) {
    this.setState({sortColumn: sortColumn, sortDirection: sortDirection});
  }

  onAddFilter(filter) {
    let newFilters = Object.assign({}, this.state.filters);
    if (filter.filterTerm) {
      newFilters[filter.column.key] = filter;
    } else {
      delete newFilters[filter.column.key];
    }

    this.setState({filters: newFilters});
  }

  onClearFilters() {
    this.setState({filters: {}});
  }

  searchBrands(rowData, currentOptions, searchTerm, callback) {
    if (searchTerm.length < 2) {
      callback(null, []);
      return;
    }

    Api.getBrands(searchTerm, true).then(
      (brands) => {
        let results = [];
        brands.forEach((brand => {
          results.push({
            id: brand.token,
            value: brand,
            text: brand.name,
            title: brand.name
          });
        }));
        callback(null, results);
      },
      (error) => {
        alert('Error finding brands: ' + error.message);
        callback(null, []);
      }
    );
  }

  getColumns() {
    return this.columns;
  }

  getRowCount() {
    return this.getRows().length;
  }

  getRows() {
    return Selectors.getRows(this.state);
  }

  getRow(index) {
    const rows = this.getRows();
    return rows[index];
  }

  emailToRow(email, index) {
    let brand1;
    let brand1ImageUrl = '';
    let description1 = '';
    if (email.selected_brands.length > 0) {
      let brand = email.selected_brands[0];
      brand1 = brand.name;
      brand1ImageUrl = brand.email_hero_image_url || '';
      description1 = brand.email_description;
    }

    let brand2;
    let brand2ImageUrl = '';
    let description2 = '';
    if (email.selected_brands.length > 1) {
      let brand = email.selected_brands[1];
      brand2 = brand.name;
      brand2ImageUrl = brand.email_hero_image_url || '';
      description2 = brand.email_description;
    }

    let brand3;
    let brand3ImageUrl = '';
    let description3 = '';
    if (email.selected_brands.length > 2) {
      let brand = email.selected_brands[2];
      brand3 = brand.name;
      brand3ImageUrl = brand.email_hero_image_url || '';
      description3 = brand.email_description;
    }

    let brand4;
    let brand4ImageUrl = '';
    let description4 = '';
    if (email.selected_brands.length > 3) {
      let brand = email.selected_brands[3];
      brand4 = brand.name;
      brand4ImageUrl = brand.email_hero_image_url || '';
      description4 = brand.email_description;
    }

    return {
      index: index,
      email: email,
      token: email.token,
      send: email.send,
      user_name: email.user_name,
      retailer_token: email.retailer_token,
      retailer_name: email.retailer_name,
      retailer_url: email.retailer_url,
      subject: email.subject,
      last_sent_at: email.last_sent_at ? Utils.millisToYMD(email.last_sent_at) : 'Never',
      send_at: Utils.millisToDateAndTime(email.send_at),
      brand1: brand1,
      brand1_image_url: brand1ImageUrl,
      brand1_description: description1,
      brand2: brand2,
      brand2_image_url: brand2ImageUrl,
      brand2_description: description2,
      brand3: brand3,
      brand3_image_url: brand3ImageUrl,
      brand3_description: description3,
      brand4: brand4,
      brand4_image_url: brand4ImageUrl,
      brand4_description: description4
    };
  }

  onGridRowUpdated({fromRow, toRow, updated}) {
    if (this.state.loading) {
      alert('Please waiting until we are done loading all emails before making changes');
      return;
    }

    let allRows = this.state.rows;
    let displayedRows = this.getRows();
    let updatedEmails = [];

    for (let rowIndex = fromRow; rowIndex <= toRow; rowIndex++) {
      let email = displayedRows[rowIndex].email;

      if (updated.subject) {
        email.subject = updated.subject;
      }
      if (updated.send_at) {
        let sendAt = new Date(updated.send_at);
        email.send_at = sendAt.getTime();
      }
      if (updated.brand1) {
        email.selected_brands[0] = this.getBrandData(updated.brand1);
      }
      if (updated.brand2) {
        email.selected_brands[1] = this.getBrandData(updated.brand2);
      }
      if (updated.brand3) {
        email.selected_brands[2] = this.getBrandData(updated.brand3);
      }
      if (updated.brand4) {
        email.selected_brands[3] = this.getBrandData(updated.brand4);
      }
      let globalIndex = displayedRows[rowIndex].index;
      let updatedRow = this.emailToRow(email, globalIndex);
      displayedRows[rowIndex] = updatedRow;
      allRows[globalIndex] = updatedRow;
      updatedEmails.push(email);
    }

    this.setState({rows: allRows});

    this.updateEmails(updatedEmails);
  }

  onCellChange(rowIndex, key) {
    if (key === 'send') {
      if (this.state.loading) {
        alert('Please waiting until we are done loading all emails before making changes');
        return;
      }
      let displayedRows = this.getRows();
      let email = displayedRows[rowIndex].email;
      email.send = !email.send;

      let allRows = this.state.rows;
      let globalIndex = displayedRows[rowIndex].index;
      let updatedRow = this.emailToRow(email, globalIndex);
      displayedRows[rowIndex] = updatedRow;
      allRows[globalIndex] = updatedRow;

      this.setState({rows: allRows});

      this.updateEmails([email]);
    }
  }

  getBrandData(brand) {
    return {
      token: brand.token,
      name: brand.name,
      url: brand.url,
      email_hero_image_url: brand.email_hero_image ? brand.email_hero_image.url : null,
      email_description: brand.email_description
    }
  }

  updateEmails(emails) {
    Api.updatePendingRecommendationEmails(emails).then(
      () => {
      },
      (error) => {
        alert(error.message);
      });
  }

  render() {
    let loadingSpinner = this.state.loading ? (<FontAwesome name="refresh" spin/>) : null;

    return (
      <div className="recommendation-emails-list">
        {loadingSpinner}
        <ReactDataGrid
          contextMenu={<EmailContextMenu getRow={this.getRow}/>}
          toolbar={<Toolbar enableFilter={true}/>}
          onGridSort={this.onGridSort}
          onAddFilter={this.onAddFilter}
          onClearFilters={this.onClearFilters}
          columns={this.getColumns()}
          rowGetter={this.getRow}
          rowsCount={this.getRowCount()}
          onGridRowsUpdated={this.onGridRowUpdated}
          enableRowSelect={false}
          enableCellSelect={true}
          rowHeight={55}
          minHeight={1000}
          rowScrollTimeout={200}
        />
      </div>
    );
  }
}

class EmailContextMenu extends React.Component {
  static propTypes = {
    getRow: PropTypes.func.isRequired,
    rowIdx: PropTypes.any,
    idx: PropTypes.any
  };

  constructor(props) {
    super(props);

    this.onSendEmail = this.onSendEmail.bind(this);
    this.onViewEmail = this.onViewEmail.bind(this);
    this.onViewRetailerMarketplace = this.onViewRetailerMarketplace.bind(this);
    this.onViewRetailerWebsite = this.onViewRetailerWebsite.bind(this);
  }

  onSendEmail(e, data) {
    let email = this.props.getRow(data.rowIdx);
    Api.sendEmail(email.token);
  }

  onViewEmail(e, data) {
    let email = this.props.getRow(data.rowIdx);
    window.open(`/api/email/view/${email.token}/html`, '_blank').focus();
  }

  onViewRetailerMarketplace(e, data) {
    let email = this.props.getRow(data.rowIdx);
    window.open(`/retailer/${email.retailer_token}`, '_blank').focus();
  }

  onViewRetailerWebsite(e, data) {
    let email = this.props.getRow(data.rowIdx);
    if (email.retailer_url) {
      window.open(email.retailer_url, '_blank').focus();
    } else {
      alert('We do not have a URL for the selected retailer');
    }
  }

  render() {
    return (
      <ContextMenu identifier="context=menu">
        <MenuItem data={{rowIdx: this.props.rowIdx, idx: this.props.idx}}
                  onClick={this.onSendEmail}>Send Email to myself!</MenuItem>
        <MenuItem data={{rowIdx: this.props.rowIdx, idx: this.props.idx}}
                  onClick={this.onViewEmail}>View Email on the web</MenuItem>
        <MenuItem data={{rowIdx: this.props.rowIdx, idx: this.props.idx}}
                  onClick={this.onViewRetailerMarketplace}>View Retailer recommendations</MenuItem>
        <MenuItem data={{rowIdx: this.props.rowIdx, idx: this.props.idx}}
                  onClick={this.onViewRetailerWebsite}>View Retailer website</MenuItem>
      </ContextMenu>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/admin/AdminRecommendations.js
 **/